export default "__VITE_ASSET__B3eO3Npb__"